import './App.css';
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import Home from './components/Home';
import Navbar from './components/Navbar';
import Products from './components/Products';
import ProductDet from './components/ProductDet';
import Footer from './components/Footer';
import Cart from './components/Cart';



function App() {
  return (
    <div>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/productDet/:id" element={<ProductDet />} />
          <Route path='/cart' element={<Cart />} />
        </Routes>
        <Footer />
      </Router>

    </div>
  );
}

export default App;
